var map = {
	"./AlarmManagement-removebg.png": 26370,
	"./Dashboard-removebg.png": 14892,
	"./Equipmentdiagnosis-removebg.png": 51203,
	"./Equipmentmanagement-removebg.png": 70399,
	"./KnowledgeBase-removebg.png": 94577,
	"./Monitoringmanagement-removebg.png": 22991,
	"./ReportManagement-removebg.png": 50195,
	"./SystemConfiguration-removebg.png": 60753,
	"./Systemlog-removebg.png": 91785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37971;